import {useState} from 'react';
import dynamic from 'next/dynamic';
import {useFormContext} from 'react-hook-form';
import {Grid, Typography} from '@mui/material';
import {CommonFields} from '../CommonFields';
const FileUploader = dynamic(
  () =>
    import('@/shared/components/forms/theme-elements/form/fileUploader').then(
      (mod) => mod.FileUploader
    ),
  {ssr: false}
);

export const Impression = () => {
  const [fileLoading, setFileLoading] = useState(false);

  const {watch, setValue} = useFormContext();

  const values = watch('menus.navigations.impression') || {};

  return (
    <Grid container spacing={1}>
      <CommonFields name={'menus.navigations.impression'} />

      <Grid item md={6} mt={2}>
        <Typography variant='h6' mb={2}>
          Primary Image
        </Typography>
        <FileUploader
          meta={{shape: 'Rectangle', size: {width: 900, height: 550}}}
          label={'Primary Image'}
          name={'menus.navigations.impression.primaryImage'}
          setFileUrl={(links) =>
            setValue(`menus.navigations.impression.primaryImage`, links[0])
          }
          destination={'landing-pages'}
          values={values?.primaryImage}
          setFileLoading={setFileLoading}
          setValue={setValue}
        />
      </Grid>

      <Grid item md={6} mt={2}>
        <Typography variant='h6' mb={2}>
          Secondary Image One
        </Typography>
        <FileUploader
          meta={{shape: 'Rectangle', size: {width: 400, height: 250}}}
          label={'Secondary Image One'}
          name={'menus.navigations.impression.secondaryImageOne'}
          setFileUrl={(links) =>
            setValue(`menus.navigations.impression.secondaryImageOne`, links[0])
          }
          destination={'landing-pages'}
          values={values?.secondaryImageOne}
          setFileLoading={setFileLoading}
          setValue={setValue}
        />
      </Grid>

      <Grid item md={6} mt={2}>
        <Typography variant='h6' mb={2}>
          Secondary Image Two
        </Typography>
        <FileUploader
          meta={{shape: 'Rectangle', size: {width: 400, height: 250}}}
          label={'Secondary Image Two'}
          name={'menus.navigations.impression.secondaryImageTwo'}
          setFileUrl={(links) =>
            setValue(`menus.navigations.impression.secondaryImageTwo`, links[0])
          }
          destination={'landing-pages'}
          values={values?.secondaryImageTwo}
          setFileLoading={setFileLoading}
          setValue={setValue}
        />
      </Grid>
    </Grid>
  );
};
